<template>
	<!-- solution & service-->
	<div class="solutionServicePage page" :class="{short: $store.getters.isHeightShort}">
		<div class="innerPage">
			<!-- 타이틀 -->
			<ul class="titleTab">
				<li :class="{on:tabIndex == 0}">
					<h2><a @click="tabMenuBtn(0)">Solution</a><BtnLink color="#A2A2A2" router-link="/solution"></BtnLink></h2>
				</li>
				<li :class="{on:tabIndex == 1}">
					<h2><a @click="tabMenuBtn(1)">Service</a><!-- <BtnLink color="#A2A2A2" link="http://nicereasy.co.kr" target="_blank"></BtnLink> --></h2>
				</li>
			</ul>
			<ul class="innerItemsWrap">
				<!-- 솔루션 -->
				<li class="innerItem" :class="{on:tabIndex===0}">
					<p class="subText" v-html="solution.title"></p>
					<swiper
						class="solutionServiceSliderSwiper solution"
						:auto-update="true"
						:options="solutionSwiperOption"
						ref="soltuionSwiper"
					>
						<swiper-slide
							class="solutionServiceSlide"
							v-for="(item, index) in solution.list"
							:key="index"
							>
							<template v-if="item.link.type==='url'">
								<a :href="item.link.url" :target="item.link.target">
									<div class="topWrap">
										<div class="titleWrap" :style="{backgroundColor: item.bgColor}">
											<h3>{{item.name}}</h3>
										</div>
										<div class="slideImgWrap">
											<img :src="$store.getters.getUrlPrefix + item.img" :alt="item.name + ' 이미지'">
										</div>
									</div>
									<div class="contentWrap">
										<h4 class="contentTitle">{{item.title}}</h4>
										<p v-html="item.text" class="contentTxt"></p>
									</div>
								</a>
							</template>
							<template v-else-if="(item.link.type!=='url')&&item.link.url">
								<router-link :to="item.link.url">
									<div class="topWrap">
										<div class="titleWrap" :style="{backgroundColor: item.bgColor}">
											<h3>{{item.name}}</h3>
										</div>
										<div class="slideImgWrap">
											<img :src="$store.getters.getUrlPrefix + item.img" :alt="item.name + ' 이미지'">
										</div>
									</div>
									<div class="contentWrap">
										<h4 class="contentTitle">{{item.title}}</h4>
										<p v-html="item.text" class="contentTxt"></p>
									</div>
								</router-link>
							</template>
							<template v-else>
								<div class="topWrap">
									<div class="titleWrap" :style="{backgroundColor: item.bgColor}">
										<h3>{{item.name}}</h3>
									</div>
									<div class="slideImgWrap">
										<img :src="$store.getters.getUrlPrefix + item.img" :alt="item.name + ' 이미지'">
									</div>
								</div>
								<div class="contentWrap">
									<h4 class="contentTitle">{{item.title}}</h4>
									<p v-html="item.text" class="contentTxt"></p>
								</div>
							</template>
						</swiper-slide>
						<div class="swiper-pagination solution"  slot="pagination"></div>
					</swiper>
					<div class="swiper-button-prev solution"></div>
					<div class="swiper-button-next solution"></div>
				</li>
				<!-- 서비스 -->
				<li class="innerItem" :class="{on:tabIndex===1}">
					<p class="subText" v-html="service.title"></p>
					<swiper
						class="solutionServiceSliderSwiper service"
						:auto-update="true"
						:options="serviceSwiperOption"
						ref="serviceSwiper"
					>
						<swiper-slide
							class="solutionServiceSlide"
							v-for="(item, index) in service.list"
							:key="index"
							>
							<template v-if="item.link.type==='url'">
								<a :href="item.link.url" :target="item.link.target">
									<div class="topWrap">
										<div class="titleWrap" :style="{backgroundColor: item.bgColor}">
											<h3>{{item.name}}</h3>
										</div>
										<div
											class="slideImgWrap"
											:style="{ backgroundImage: 'url(' + $store.getters.getUrlPrefix + item.img + ')' }"
										>
										</div>
									</div>
									<div class="contentWrap">
										<h4 class="contentTitle">{{item.title}}</h4>
										<p v-html="item.text" class="contentTxt"></p>
									</div>
								</a>
							</template>
							<template v-else-if="(item.link.type!=='url')&&item.link.url">
								<router-link :to="item.link.url">
									<div class="topWrap">
										<div class="titleWrap" :style="{backgroundColor: item.bgColor}">
											<h3>{{item.name}}</h3>
										</div>
										<div
											class="slideImgWrap"
											:style="{ backgroundImage: 'url(' + $store.getters.getUrlPrefix + item.img + ')' }"
										>
										</div>
									</div>
									<div class="contentWrap">
										<h4 class="contentTitle">{{item.title}}</h4>
										<p v-html="item.text" class="contentTxt"></p>
									</div>
								</router-link>
							</template>
							<template v-else>
								<div class="topWrap">
									<div class="titleWrap" :style="{backgroundColor: item.bgColor}">
										<h3>{{item.name}}</h3>
									</div>
									<div
										class="slideImgWrap"
										:style="{ backgroundImage: 'url(' + $store.getters.getUrlPrefix+item.img + ')' }"
									>
									</div>
								</div>
								<div class="contentWrap">
									<h4 class="contentTitle">{{item.title}}</h4>
									<p v-html="item.text" class="contentTxt"></p>
								</div>
							</template>

						</swiper-slide>
						<div class="swiper-pagination service"  slot="pagination"></div>
					</swiper>
					<div class="swiper-button-prev service"></div>
					<div class="swiper-button-next service"></div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import BtnLink from '../../components/ButtonLinkPage'

export default {
	name: 'MainSolutionService',
	components: {
		BtnLink
	},
	props: {
		solution: {
			title: '많은 웹 기반의 놀라운 솔루션이 준비되어 있습니다.<br>내용을 살펴보고 시연해보세요.',
			list: [
				/* {
					link: '/solutionpdfviewer',
					name: 'PDF Viewer',
					title: '설치 NO! 바로 확인하고 바로 다운로드!',
					bgColor: '#D6DDE2',
					text: '약관, 증명서 영수증, 책 등<br>보거나 확인하기 위해 다운로드 한 후 읽으시나요?<br>이제 웹에서 바로 바로 확인하고 검색하고 다운로드하세요.<br>티에스 피디에프뷰어는 빠르고 정확합니다.',
					img: '',
					selected: false
				},
				*/
			]
		},
		service: {
			title: '두손소프트가 제공 중인 서비스입니다.<br>더 좋은 품질을 위해 노력하겠습니다.',
			list: [
				/* {
					link: '',
					name: 'Nicereasy',
					title: '법인 재무 컨설팅용 기업분석보고서 서비스를 만나보세요.',
					text: '기업용 재무 컨설팅을 위한 맞춤형 기업분석 보고서!<br>나이스알리지 기업분석보고서를 통해<br>보험, 재무 영업에 신뢰를 더하세요!<br>두손소프트와 나이스평가정보가 함께합니다.',
					img: require('@/assets/images/img-solution-webscanner@2x.png'),
					selected: true
				},
				{
					link: '',
					name: 'A Service in preparation',
					title: '새로운 서비스를 준비 중입니다.',
					text: '두손소프트에서 준비 중인 서비스입니다.<br>여러분을 만나기 위해 부지런히 제대로 준비 하겠습니다.',
					img: require('@/assets/images/img-solution-tsroomdeco@2x.png'),
					selected: false
				} */
			]
		}
	},
	data () {
		return {
			tabIndex: 0,
			solutionSwiperOption: {
				loop: false,
				speed: 820,
				slidesPerView: 1,
				spaceBetween: 0,
				slidesPerGroup: 1,
				loopFillGroupWithBlank: true,
				autoplay: {
					delay: 5000
				},
				touchStartPreventDefault: false,
				navigation: {
					nextEl: '.swiper-button-next.solution',
					prevEl: '.swiper-button-prev.solution'
				},
				pagination: {
					el: '.swiper-pagination.solution',
					type: 'bullets',
					clickable: true
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 20
					},
					1280: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetween: 30
					}
				}
			},
			serviceSwiperOption: {
				loop: false,
				speed: 820,
				slidesPerView: 1,
				spaceBetween: 0,
				slidesPerGroup: 1,
				loopFillGroupWithBlank: true,
				/* autoplay: {
					delay: 5000
				}, */
				touchStartPreventDefault: false,
				navigation: {
					nextEl: '.swiper-button-next.service',
					prevEl: '.swiper-button-prev.service'
				},
				watchOverflow: true,
				pagination: {
					el: '.swiper-pagination.service',
					type: 'bullets',
					clickable: true
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 20
					}
				}
			}
		}
	},
	computed: {
		/* mainBannerSwiper () {
			return this.$refs.mainBannerSwiper.$swiper
		} */
	},
	mounted () {
		// data load
	},
	destroyed () {
	},
	methods: {
		tabMenuBtn (idx) {
			this.tabIndex = idx
		}
	}
}
</script>

<style lang="scss">
@import '@/css/variables.scss';

/* page 공통 */
.imgWrap {
	position: relative;
	width: 100%;
	height: 100%;
	pointer-events: none;
	&.imgCenter {
		overflow: hidden;
	}
	img {
		position: absolute;
		top:50%; left: 50%;
		width: 100%; height: auto;
		max-height: none; max-width: 100%;
		transform: translate(-50%,-50%);
	}
	&.horizontal img{
		width: auto; height: 100%;
		max-height: 100%; max-width: none;
	}
}

/* solution */
.solutionServicePage {
	background-color: #F6F6F6;
	.innerPage {
		position: absolute;
		top: 0; left: 0;
		width: 100%; height: 100%;
		padding: 5vh 60px;
		.titleTab {
			position: relative;
			display: flex;
			margin-bottom: 5vh;
			> li {
				position: relative;
				padding-right: 70px; padding-left: 70px;
				&::after {
					content: '';
					display: block;
					position: absolute;
					right: 0; top: 10%;
					height: 80%; width: 1px;
					background-color: rgba($c-gray, 0.29);
				}
				&:last-child::after {
					content: none;
				}
				&:first-child {
					padding-left: 0;
				}
				h2 {
					color: $c-gray-light2; font-size: $title-huge-small; font-weight: bold;
					a { color: $c-gray-light2 }
					.btnLinkWrap {
						display: none;
						margin-left: 10px;
						vertical-align: middle;
						.btnLink {
							padding: 0;
							margin-left: 0;
						}
					}
				}
				&.on {
					h2 {
						color:$c-blue-m;
						a { color:$c-blue-m; }
						.btnLinkWrap {
							display: inline-block;
						}
					}
				}
			}
		}
		.subText {
			color: $c-gray; font-size: $text-medium;
			max-width: 1600px;
			margin: 0 auto 20px;
		}
		.innerItemsWrap {
			padding: 6vh 30px;
			margin-left: -60px;
			margin-right: -60px;
			background-color: #fff;
			.innerItem {
				position: relative;
				width: 100%; max-width: 1680px;
				padding: 0 40px;
				margin: 0 auto;
				display: none;
				&.on {
					display: block;
				}
				.swiper-button-prev.solution,
				.swiper-button-next.solution,
				.swiper-button-prev.service,
				.swiper-button-next.service {
					color: $c-gray-black;
					width: 16px; height: 27px;
				}
				.swiper-button-prev.solution:after,
				.swiper-button-next.solution:after,
				.swiper-button-prev.service:after,
				.swiper-button-next.service:after {
					font-size: 32px;
				}
			}
		}
	}
	&.short {
		.innerPage {
			padding: 2vh 60px;
			.titleTab {
				margin-bottom: 3vh;
				> li {
					h2 {
						font-size: $title-medium;
					}
				}
			}
			.subText {
				font-size: $text-normal-small;
			}
			.innerItemsWrap {
				padding: 3vh 30px;
			}
		}
	}
}
.solutionServiceSliderSwiper {
	.swiper-pagination-bullet {
		border-radius: 0;
		height: 4px;
	}
	&.swiper-container-horizontal > .swiper-pagination-bullets {
		bottom: 10px;
		right: 0; left: auto;
		width: auto;
	}
	&.swiper-container {
		background-color: #fff;
		max-width: 1600px;
		padding-bottom: 40px;
	}
	.solutionServiceSlide {
		$cellW: 15vw;
		.topWrap {
			display: flex;
			margin-bottom: 12px;
			.titleWrap {
				padding: 25px 34px;
				font-size: $title-normal-small;
				color: $c-gray-black;
				h3 {
					line-height: 1.2em;
				}
			}
			.slideImgWrap {
				img {
					pointer-events: none;
					width: auto; height: 100%;
				}
			}
		}
		.contentWrap {
			.contentTitle {
				font-size: $title-normal-small; color: $c-gray-black; font-weight: bold;
				margin-bottom: 20px;
			}
			.contentTxt {
				font-size: $text-small; color: $c-gray-m; letter-spacing: $lspace-short;
			}
		}
	}
	&.solution {
		$cellW: 15vw;
		.solutionServiceSlide {
			.topWrap {
				.titleWrap {
					width: $cellW; height: $cellW;
					max-width: 250px; max-height: 250px;
					color: $c-gray-black;
				}
				.slideImgWrap {
					width: $cellW; height: $cellW;
					max-width: 250px; max-height: 250px;
				}
			}
			.contentWrap {
				width: $cellW*2;
			}
		}
	}
	&.service {
		$cellW: 30vw;
		.solutionServiceSlide {
			.topWrap {
				display: block;
				height: $cellW; max-height: 250px;
				.titleWrap {
					position: absolute;
					z-index: 1;
					width: 100%; height: $cellW;
					max-height: 250px;
					color: $c-white;
					background-color: rgba(0,0,0,0.12);
				}
				.slideImgWrap {
					position: absolute;
					width: 100%; height: $cellW;
					max-height: 250px;
					background-size: cover; background-position: center;
				}
			}
			.contentWrap {
				width: 100%;
			}
		}
	}
}
.short {
	.solutionServiceSliderSwiper {
		$cellW: 10vw;
		.solutionServiceSlide {
			.contentWrap {
				.contentTitle {
					font-size: $title-xxsmall;
					margin-bottom: 10px;
				}
				.contentTxt {
					font-size: $text-xtiny;
				}
			}
		}
		&.solution {
			.solutionServiceSlide {
				.topWrap {
					.titleWrap {
						width: $cellW; height: $cellW;
					}
					.slideImgWrap {
						width: $cellW; height: $cellW;
					}
				}
				.contentWrap {
					width: $cellW*2;
				}
			}
		}
		&.service {
			.solutionServiceSlide {
				.topWrap {
					height: $cellW; max-height: 250px;
					.titleWrap {
						width: 100%; height: $cellW; max-height: $cellW;
					}
					.slideImgWrap {
						width: 100%; height: $cellW; max-height: $cellW;
					}
				}
				.contentWrap {
					width: 100%;
				}
			}
		}
	}
}
/*
  ##Device = Laptops, Desktops
  ##Screen = B/w 1025px to 1280px
*/
@media (max-width: 1280px) and (min-width: 1025px) {
	//CSS
	$cellW: 20vw;
	.solutionServicePage {
		.innerPage {
			.titleTab {
				margin-bottom: 4vh;
				> li {
					padding-right: 70px; padding-left: 70px;
					&::after {
						right: 0; top: 10%;
						height: 80%; width: 1px;
					}
					&:first-child {
						padding-left: 0;
					}
					h2 {
						font-size: $title-huge-small;
						a { color: $c-gray-light2 }
					}
					&.on {
						h2 {
							a { color:$c-blue-m; }
						}
					}
				}
			}
		}
	}
	.solutionServiceSliderSwiper {
		&.swiper-container {
			max-width: 1024px;
			padding-bottom: 30px;
		}
		.solutionServiceSlide {
			.topWrap {
				margin-bottom: 12px;
				.titleWrap {
					padding: 25px 34px;
					font-size: $title-normal-small;
					h3 {
						line-height: 1.2em;
					}
				}
				.slideImgWrap {
					img {
						width: auto; height: 100%;
					}
				}
			}
		}
		&.solution {
			.solutionServiceSlide {
				.topWrap {
					.titleWrap {
						width: $cellW; height: $cellW;
						max-width: 250px; max-height: 250px;
					}
					.slideImgWrap {
						width: $cellW; height: $cellW;
						max-width: 250px; max-height: 250px;
					}
				}
				.contentWrap {
					width: $cellW*2;
				}
			}
		}
		&.service {
			.solutionServiceSlide {
				.topWrap {
					.titleWrap {
						width: 100%; height: $cellW;
						max-height: 250px;
					}
					.slideImgWrap {
						width: 100%; height: $cellW;
						max-height: 250px;
					}
				}
				.contentWrap {
					width: 100%;
				}
			}
		}
	}
	.short {
		.innerPage {
			.solutionServiceSliderSwiper {
				&.solution {
					.solutionServiceSlide {
						.topWrap {
							.titleWrap {
								width: 100%; height: $cellW;
								max-height: 250px;
							}
							.slideImgWrap {
								width: 100%; height: $cellW;
								max-height: 250px;
							}
						}
						.contentWrap {
							width: $cellW*2;
						}
					}
				}
			}
		}
	}
}

/*
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/
@media (max-width: 1024px) and (min-width: 768px) {
	//css
	$cellW: 20vw;
	.solutionServicePage {
		.innerPage {
			.titleTab {
				margin-bottom: 4vh;
				> li {
					padding-right: 40px; padding-left: 40px;
					&::after {
						right: 0; top: 10%;
						height: 80%; width: 1px;
					}
					&:first-child {
						padding-left: 0;
					}
					h2 {
						font-size: $title-medium-small;
						// a { color: $c-gray-light2 }
					}
					&.on {
						h2 {
							a { color:$c-blue-m; }
						}
					}
				}
			}
			.subText {
				font-size: $text-small;
				max-width: 1600px;
				margin: 0 auto 20px;
			}
			.innerItemsWrap {
				padding: 4vh 30px;
				.innerItem {
					padding: 0 30px;
					.swiper-button-prev.solution,
					.swiper-button-next.solution,
					.swiper-button-prev.service,
					.swiper-button-next.service {
						width: 16px; height: 27px;
					}
					.swiper-button-prev.solution:after,
					.swiper-button-next.solution:after,
					.swiper-button-prev.service:after,
					.swiper-button-next.service:after {
						font-size: 28px;
					}
				}
			}
		}
	}
	.solutionServiceSliderSwiper {
		&.swiper-container {
			max-width: 1024px;
			padding-bottom: 30px;
			width: calc(80vw + 30px);
		}
		.solutionServiceSlide {
			.topWrap {
				margin-bottom: 12px;
				.titleWrap {
					padding: 25px 34px;
					font-size: $title-xsmall;
					h3 {
						line-height: 1.2em;
					}
				}
			}
			.contentWrap {
				.contentTitle {
					font-size: $title-tiny;
					margin-bottom: 8px;
				}
				.contentTxt {
					font-size: $text-tiny;
				}
			}
		}
		&.solution {
			.solutionServiceSlide {
				.topWrap {
					.titleWrap {
						width: $cellW; height: $cellW;
						max-width: 250px; max-height: 250px;
					}
					.slideImgWrap {
						width: $cellW; height: $cellW;
						max-width: 250px; max-height: 250px;
					}
				}
				.contentWrap {
					width: $cellW*2;
				}
			}
		}
		&.service {
			.solutionServiceSlide {
				.topWrap {
					.titleWrap {
						width: 100%; height: $cellW;
						max-height: 250px;
					}
					.slideImgWrap {
						width: 100%; height: $cellW;
						max-height: 250px;
					}
				}
				.contentWrap {
					width: 100%;
				}
			}
		}
	}
	.short {
		.innerPage {
			.solutionServiceSliderSwiper {
				&.solution {
					.solutionServiceSlide {
						.topWrap {
							.titleWrap {
								width: 100%; height: $cellW;
								max-height: 250px;
							}
							.slideImgWrap {
								width: 100%; height: $cellW;
								max-height: 250px;
							}
						}
						.contentWrap {
							width: $cellW*2;
						}
					}
				}
			}
		}
	}
}

/*
  ##Device = Tablets, Ipads (landscape)
  ##Screen = B/w 768px to 1024px
*/
@media (max-width: 1024px) and (min-width: 768px) and (orientation: landscape) {
	//CSS
}

/*
  ##Device = Low Resolution Tablets, Mobiles (Landscape)
  ##Screen = B/w 481px to 767px
*/
@media (max-width: 767px) and (min-width: 481px) {
	//CSS
	$margin: 20px;
	.solutionServicePage {
		.innerPage {
			padding: 5vh $margin;
			.titleTab {
				margin-bottom: 4vh;
				> li {
					padding-right: 20px; padding-left: 20px;
					&::after {
						right: 0; top: 10%;
						height: 80%; width: 1px;
					}
					&:first-child {
						padding-left: 0;
					}
					h2 {
						font-size: $title-xsmall;
							.btnLinkWrap {
								display: inline-block;
								width: 19px; height: 30px;
								margin-left: 10px;
								vertical-align: middle;
								.btnLink {
									padding: 0;
									margin-left: 0;
								}
							}
					}
					&.on {
						h2 {
							a { color:$c-blue-m; }
						}
					}
				}
			}
			.subText {
				font-size: $text-small;
				max-width: 1600px;
				margin: 0 auto 20px;
			}
			.innerItemsWrap {
				padding: 2vh 10px;
				margin-left: -$margin; margin-right: -$margin;
				.innerItem {
					padding: 0 10px;
					.swiper-button-prev.solution,
					.swiper-button-next.solution,
					.swiper-button-prev.service,
					.swiper-button-next.service {
						width: 16px; height: 27px;
						display: none;
					}
					.swiper-button-prev.solution,
					.swiper-button-prev.service {
						left: 0;
					}
					.swiper-button-next.solution,
					.swiper-button-next.service {
						right: 0;
					}
					.swiper-button-prev.solution:after,
					.swiper-button-next.solution:after,
					.swiper-button-prev.service:after,
					.swiper-button-next.service:after {
						font-size: 14px;
					}
				}
			}
		}
	}
	.solutionServiceSliderSwiper {
		$cellW: 45vw;
		&.swiper-container {
			padding-bottom: 30px;
			width: 90vw;
		}
		.solutionServiceSlide {
			.topWrap {
				margin-bottom: 12px;
				.titleWrap {
					padding: 18px 22px;
					font-size: $title-xxsmall;
					h3 {
						line-height: 1.2em;
					}
				}
			}
			.contentWrap {
				.contentTitle {
					font-size: $title-tiny;
					margin-bottom: 8px;
				}
				.contentTxt {
					font-size: $text-xtiny;
				}
			}
		}
		&.solution {
			.solutionServiceSlide {
				.topWrap {
					.titleWrap {
						width: $cellW; height: $cellW;
						max-width: 250px; max-height: 250px;
					}
					.slideImgWrap {
						width: $cellW; height: $cellW;
						max-width: 250px; max-height: 250px;
					}
				}
				.contentWrap {
					width: $cellW*2;
				}
			}
		}
		&.service {
			.solutionServiceSlide {
				.topWrap {
					height: $cellW;
					.titleWrap {
						width: 100%; height: $cellW;
						max-height: 250px;
					}
					.slideImgWrap {
						width: 100%; height: $cellW;
						max-height: 250px;
					}
				}
				.contentWrap {
					width: 100%;
				}
			}
		}
	}
}

/*
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/
@media (max-width: 480px) and (min-width: $mnWMobile) {
	//CSS
	$margin: 20px;
	.solutionServicePage {
		.innerPage {
			padding: 3vh $margin;
			.titleTab {
				margin-bottom: 1.5vh;
				> li {
					padding-right: 20px; padding-left: 20px;
					&::after {
						right: 0; top: 10%;
						height: 80%; width: 1px;
					}
					&:first-child {
						padding-left: 0;
					}
					h2 {
						font-size: $title-xsmall;
							.btnLinkWrap {
								display: inline-block;
								width: 19px; height: 30px;
								margin-left: 10px;
								vertical-align: middle;
								.btnLink {
									padding: 0;
									margin-left: 0;
								}
							}
					}
					&.on {
						h2 {
							a { color:$c-blue-m; }
						}
					}
				}
			}
			.subText {
				font-size: $text-tiny;
				max-width: 1600px;
				margin: 0 auto 10px;
			}
			.innerItemsWrap {
				padding: 2vh 10px;
				margin-left: -$margin; margin-right: -$margin;
				.innerItem {
					padding: 0 10px;
					.swiper-button-prev.solution,
					.swiper-button-next.solution,
					.swiper-button-prev.service,
					.swiper-button-next.service {
						width: 16px; height: 27px;
						display: none;
					}
					.swiper-button-prev.solution,
					.swiper-button-prev.service {
						left: 0;
					}
					.swiper-button-next.solution,
					.swiper-button-next.service {
						right: 0;
					}
					.swiper-button-prev.solution:after,
					.swiper-button-next.solution:after,
					.swiper-button-prev.service:after,
					.swiper-button-next.service:after {
						font-size: 14px;
					}
				}
			}
		}
	}
	.solutionServiceSliderSwiper {
		$cellW: 45vw;
		&.swiper-container {
			padding-bottom: 30px;
			width: 90vw;
		}
		.solutionServiceSlide {
			.topWrap {
				margin-bottom: 12px;
				.titleWrap {
					padding: 18px 22px;
					font-size: $title-xxsmall;
					h3 {
						line-height: 1.2em;
					}
				}
			}
			.contentWrap {
				.contentTitle {
					font-size: $title-xtiny;
					margin-bottom: 6px;
				}
				.contentTxt {
					font-size: $text-xtiny;
				}
			}
		}
		&.solution {
			.solutionServiceSlide {
				.topWrap {
					.titleWrap {
						width: $cellW; height: $cellW;
						max-width: 250px; max-height: 250px;
					}
					.slideImgWrap {
						width: $cellW; height: $cellW;
						max-width: 250px; max-height: 250px;
					}
				}
				.contentWrap {
					width: $cellW*2;
				}
			}
		}
		&.service {
			.solutionServiceSlide {
				.topWrap {
					height: $cellW;
					.titleWrap {
						width: 100%; height: $cellW;
						max-height: 250px;
					}
					.slideImgWrap {
						width: 100%; height: $cellW;
						max-height: 250px;
					}
				}
				.contentWrap {
					width: 100%;
				}
			}
		}
	}
}
</style>
